/* <fitpod-header-menu>: the SiteHeader mobile menu (below 1080px).
   Opens and closes at once (no slide), full width under the header. Escape closes and returns focus to the toggle;
   opening moves focus to the first link; Tab stays inside the bar and the menu while it is open. */
class FitpodHeaderMenu extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector("[data-menu-toggle]");
    this.panel = this.querySelector("[data-menu-panel]");
    if (!this.toggle || !this.panel) return;
    this.onKey = this.onKey.bind(this);
    this.onResize = this.onResize.bind(this);
    this.toggle.addEventListener("click", () => (this.isOpen() ? this.close() : this.open()));
    window.addEventListener("resize", this.onResize);
  }
  disconnectedCallback() {
    document.removeEventListener("keydown", this.onKey);
    window.removeEventListener("resize", this.onResize);
  }
  isOpen() { return this.toggle.getAttribute("aria-expanded") === "true"; }
  setIcon(open) {
    this.toggle.querySelector("[data-icon-open]").hidden = open;
    this.toggle.querySelector("[data-icon-close]").hidden = !open;
    this.toggle.setAttribute("aria-label", open ? this.toggle.dataset.labelClose : this.toggle.dataset.labelOpen);
  }
  open() {
    this.panel.hidden = false;
    this.toggle.setAttribute("aria-expanded", "true");
    this.setIcon(true);
    document.addEventListener("keydown", this.onKey);
    const first = this.panel.querySelector("a, button");
    if (first) first.focus();
  }
  close(returnFocus = true) {
    this.panel.hidden = true;
    this.toggle.setAttribute("aria-expanded", "false");
    this.setIcon(false);
    document.removeEventListener("keydown", this.onKey);
    if (returnFocus) this.toggle.focus();
  }
  onKey(e) {
    if (e.key === "Escape") { e.preventDefault(); this.close(); return; }
    if (e.key !== "Tab") return;
    const items = [...this.querySelectorAll("a[href], button:not([disabled]), input:not([disabled])")].filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  onResize() { if (this.isOpen() && window.innerWidth >= 1080) this.close(false); }
}
if (!customElements.get("fitpod-header-menu")) customElements.define("fitpod-header-menu", FitpodHeaderMenu);
